import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Box, IconButton } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { editItineraryFieldsTranslation } from '../../../i18n/translateHelpers'
import { FormText } from '../formComponents/formText'
import { TodoValidationSchema } from './todoEditItem'
interface ITaskProps {
    index: number
    onDeleteTask: (index: number) => void
    showDelete?: boolean
    shouldFocus?: boolean
    onAddTask: () => void
}
export const Task = ({
    index,
    onDeleteTask,
    showDelete = true,
    shouldFocus = false,
    onAddTask,
}: ITaskProps) => {
    const { control } = useFormContext<TodoValidationSchema>()

    // Create a ref for the input element
    const inputRef = useRef<HTMLInputElement | null>(null)
    // Effect to focus the input when shouldFocus is true
    useEffect(() => {
        if (shouldFocus && inputRef.current) {
            // Use setTimeout to ensure the DOM has updated
            setTimeout(() => {
                inputRef.current?.focus()
                inputRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                    block: 'center',
                })
            }, 100)
        }
    }, [shouldFocus])
    // Reset the ref when we're unmounting
    useEffect(() => {
        return () => {
            inputRef.current = null
        }
    }, [])
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: `1fr auto`,
                gap: '8px',
                alignItems: 'start',
            }}
        >
            <FormText
                key={index}
                required
                inputRef={inputRef}
                name={`tasks.${index}.name`}
                control={control as any}
                muiTextFieldProps={{
                    onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault()
                            onAddTask()
                        }
                    },
                }}
                fieldLabel={
                    index > 0
                        ? undefined
                        : editItineraryFieldsTranslation('Task Name')
                }
            />
            {showDelete && (
                <IconButton
                    tabIndex={-1}
                    sx={{ '&:hover': { backgroundColor: 'transparent' } }}
                    aria-label="Delete"
                    onClick={() => onDeleteTask(index)}
                >
                    <Box
                        position={'relative'}
                        top={index === 0 ? '30px' : '22px'}
                    >
                        <Icon
                            iconColour={ColoursObj.states.error}
                            name={'Delete'}
                        />
                    </Box>
                </IconButton>
            )}
        </Box>
    )
}
